export interface CurriculumCategory {
  category: string;
  stage: string;
  units: string[];
}

export const CURRICULUM: CurriculumCategory[] = [
  {
    category: '중1-1',
    stage: '중학교',
    units: [
      '소인수분해',
      '정수와 유리수',
      '문자와 식',
      '일차방정식',
      '좌표평면과 그래프',
    ],
  },
  {
    category: '중1-2',
    stage: '중학교',
    units: [
      '기본도형',
      '작도와 합동',
      '평면도형의 성질',
      '입체도형의 성질',
      '자료의 정리와 해석',
    ],
  },
  {
    category: '중2-1',
    stage: '중학교',
    units: [
      '유리수와 순환소수',
      '식의 계산',
      '일차부등식',
      '연립일차방정식',
      '일차함수와 그래프',
      '일차함수와 일차방정식의 관계',
    ],
  },
  {
    category: '중2-2',
    stage: '중학교',
    units: [
      '삼각형의 성질',
      '사각형의 성질',
      '도형의 닮음',
      '평행선과 선분의 길이의 비',
      '피타고라스 정리',
      '확률',
    ],
  },
  {
    category: '중3-1',
    stage: '중학교',
    units: [
      '제곱근과 실수',
      '근호를 포함한 식의 계산',
      '다항식의 곱셈',
      '인수분해',
      '이차방정식',
      '이차방정식의 활용',
      '이차함수와 그래프',
    ],
  },
  {
    category: '중3-2',
    stage: '중학교',
    units: [
      '삼각비',
      '삼각비의 활용',
      '원의 성질',
      '원주각',
      '대푯값과 산포도',
      '상관관계',
    ],
  },
  {
    category: '공통수학1',
    stage: '고등학교',
    units: [
      '다항식의 연산',
      '항등식과 나머지정리',
      '인수분해',
      '복소수와 이차방정식',
      '이차방정식과 이차함수',
      '여러 가지 방정식',
      '여러 가지 부등식',
      '순열',
      '조합',
      '행렬과 그 연산',
    ],
  },
  {
    category: '공통수학2',
    stage: '고등학교',
    units: [
      '평면좌표',
      '직선의 방정식',
      '원의 방정식',
      '도형의 이동',
      '집합',
      '명제',
      '함수',
      '유리함수와 무리함수',
    ],
  },
  {
    category: '대수',
    stage: '고등학교',
    units: [
      '지수와 로그',
      '지수함수',
      '로그함수',
      '삼각함수',
      '삼각함수의 그래프',
      '사인법칙과 코사인법칙',
      '등차수열과 등비수열',
      '수열의 합',
      '수학적 귀납법',
    ],
  },
  {
    category: '미적분1',
    stage: '고등학교',
    units: [
      '함수의 극한',
      '함수의 연속',
      '미분계수와 도함수',
      '접선의 방정식과 평균값 정리',
      '함수의 증가와 감소',
      '함수의 극대와 극소',
      '방정식과 부등식에의 활용',
      '속도와 가속도',
      '부정적분',
      '정적분',
      '정적분의 활용',
    ],
  },
  {
    category: '미적분2',
    stage: '고등학교',
    units: [
      '수열의 극한',
      '급수',
      '여러 가지 함수의 미분',
      '여러 가지 미분법',
      '도함수의 활용',
      '여러 가지 적분법',
      '정적분의 활용',
    ],
  },
  {
    category: '확률과 통계',
    stage: '고등학교',
    units: [
      '순열과 조합',
      '이항정리',
      '확률의 개념과 활용',
      '조건부확률',
      '확률변수와 확률분포',
      '통계적 추정',
    ],
  },
  {
    category: '기하',
    stage: '고등학교',
    units: [
      '이차곡선',
      '이차곡선의 접선',
      '벡터의 연산',
      '벡터의 내적',
      '도형의 방정식에의 활용',
      '공간도형',
      '공간좌표',
    ],
  },
];

export const ALL_CATEGORY_NAMES = CURRICULUM.map((c) => c.category);

export function getUnitsByCategory(category: string): string[] {
  return CURRICULUM.find((c) => c.category === category)?.units ?? [];
}